import { jsx as e, Fragment as l, jsxs as c } from "react/jsx-runtime";
import { c as y } from "./clsx-OuTLNxxd.js";
import './Label.css';const g = "320px", h = "600px", a = "1025px", m = "_label_14ro7_32", d = "_hasMobileText_14ro7_39", i = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: g,
  "mobile-wide": "480px",
  tablet: h,
  "tablet-wide": "800px",
  desktop: a,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  label: m,
  hasMobileText: d,
  "size-s": "_size-s_14ro7_54",
  "size-m": "_size-m_14ro7_61",
  "size-l": "_size-l_14ro7_67"
}, z = ({
  children: x,
  className: o,
  mobileText: t,
  size: n = "m",
  ...s
}) => /* @__PURE__ */ e(
  "label",
  {
    className: y(i.label, i[`size-${n}`], { [i.hasMobileText]: !!t }, o),
    "data-cxy-name": "label",
    ...s,
    children: /* @__PURE__ */ e(l, { children: t ? /* @__PURE__ */ c(l, { children: [
      /* @__PURE__ */ e("span", { "data-testid": "mobile-label", children: t }),
      /* @__PURE__ */ e("span", { "data-testid": "label", children: x })
    ] }) : x })
  }
);
export {
  z as L
};
